import {
  VISITED_URL_EVENT_TRIGGER,
  VISITED_URL_EVENT_TRIGGERS,
} from '@mm/api-routes';
import { VisitedUrlEventTrigger } from '@mm/state/model/SignalModel';
import AuthenticatedController from './AuthenticatedController';

type PartialTokenlessTrigger = Partial<Omit<VisitedUrlEventTrigger, 'id'>>;

export type UpdateEventTrigger = PartialTokenlessTrigger & {
  id: number;
};

export type CreateEventTrigger = PartialTokenlessTrigger;

export default class SignalVisitedUrlEventTriggersController extends AuthenticatedController {
  static async getById(configurationId: number, id: number) {
    return super.get(VISITED_URL_EVENT_TRIGGER(configurationId, id));
  }

  static async getAll(configurationId: number) {
    return super.get(VISITED_URL_EVENT_TRIGGERS(configurationId));
  }

  static async remove(configurationId: number, id: number) {
    return super.delete(VISITED_URL_EVENT_TRIGGER(configurationId, id));
  }

  static async create(
    configurationId: number,
    visitedUrlEventTrigger: CreateEventTrigger,
  ): Promise<VisitedUrlEventTrigger> {
    return super.post(
      VISITED_URL_EVENT_TRIGGERS(configurationId),
      visitedUrlEventTrigger,
    );
  }

  static async update(
    configurationId: number,
    visitedUrlEventTrigger: UpdateEventTrigger,
  ): Promise<VisitedUrlEventTrigger> {
    return super.put(
      VISITED_URL_EVENT_TRIGGER(configurationId, visitedUrlEventTrigger.id),
      visitedUrlEventTrigger,
    );
  }
}
